<template>
    <div 
    class="progress"
    :style="'height:20px'">

        <div 
        class="progress-bar bg-primary" 
        role="progressbar" 
        :style="'width:'+progress+'%'" 
        :aria-valuenow="progress" 
        aria-valuemin="0" 
        aria-valuemax="100">

            <span>
                <b>{{progress}}</b> %
            </span>

        </div> <!-- /.progress-bar -->

    </div> <!-- /.progress -->
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {

        computed: {

            ...mapGetters('booking', [
                'progress'
            ])

        },


    }
</script>